/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enMonitor from "config/message/monitor/en.json";
import enNotification from "config/message/notification/en.json";
import jaMonitor from "config/message/monitor/ja.json";
import jaNotification from "config/message/notification/ja.json";

export const defaultNS = "monitor";

i18next.use(initReactI18next).init({
  debug: process.env.REACT_APP_DEBUG_LOG === "true",
  fallbackLng: "en",
  defaultNS,
  resources: {
    en: {
      monitor: enMonitor,
      notification: enNotification,
    },
    ja: {
      monitor: jaMonitor,
      notification: jaNotification,
    },
  },
});

export default i18next;
